// @flow
import { backgroundOverlay } from '../stylesheets/background.css'

export const getOverlayElement = (overlay: ?boolean | ?Object): string => {
  let defaultOverlay = {
    opacity: 0.8,
    color: '#000'
  }

  if (overlay === true) {
    return `<div class="${backgroundOverlay}" style="background-color: ${defaultOverlay.color}; opacity: ${defaultOverlay.opacity}"></div>`
  }

  if (overlay) {
    Object.assign(defaultOverlay, overlay)
    return `<div class="${backgroundOverlay}" style="background-color: ${defaultOverlay.color}; opacity: ${defaultOverlay.opacity}"></div>`
  }

  return ''
}



// WEBPACK FOOTER //
// ./src/shared/utils/renderUtils.js